// src/index.tsx

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import { ThemeProvider } from "@mui/material/styles";
import appTheme from "./theme/appTheme";
import { TeacherProvider } from "./context/TeacherContext";
import { FamilyProvider } from "./context/FamilyContext";
import CssBaseline from "@mui/material/CssBaseline"; // Import CssBaseline for consistent styling
import "./index.css";
import 'katex/dist/katex.min.css';

// Create a font link element to load Nunito font
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap';
document.head.appendChild(fontLink);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <HelmetProvider>
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      <BrowserRouter>
        <TeacherProvider>
          <FamilyProvider>
            <App />
          </FamilyProvider>
        </TeacherProvider>
      </BrowserRouter>
    </ThemeProvider>
  </HelmetProvider>
);
